import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

import TextCard, { ITextCard } from "@/components/cards/TextCard";

// ----------------------------------------------------------------------------------------------

export type ITextWithGridSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  cards?: ITextCard[];
};

const TextWithGridSection: FC<ITextWithGridSectionProps> = (props) => {
  const { heading, cards, className, ...other } = props;

  return (
    <section
      className={clsx("container py-5 lg:py-8 xl:py-[50px]", className)}
      {...other}
    >
      {/* section title  */}
      {heading && (
        <div className="mb-3 w-full md:w-4/5 lg:mb-6 xl:mb-11">
          <h2 className="text-h5 font-medium text-black-900 lg:text-h3 xl:text-h2">
            {heading}
          </h2>
        </div>
      )}

      {/* grid layout  */}
      {cards && cards.length !== 0 && (
        <div className="grid grid-cols-1 gap-5 *:bg-primary-100 md:grid-cols-4 lg:gap-7 xl:grid-cols-6">
          {cards.map((card, idx) => (
            <TextCard
              key={idx}
              className={clsx(
                "w-full",
                card.size === "xsm" && "md:col-span-2",
                card.size === "sm" && `md:col-span-2 xl:col-span-3`,
                card.size === "lg" && `md:col-span-2 xl:col-span-4`,
                card.size === "xlg" && `md:col-span-2 xl:col-span-6`,
              )}
              heading={card.heading}
              headingClass="break-words text-h5 font-normal text-black-900 lg:text-h4"
              description={card.description}
              descriptionClass="break-words text-base font-normal text-gray-500"
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default TextWithGridSection;
